import { isPresent } from 'utils/isPresent';
import TasksApi from '../Api/TasksApi'
import { showErrorDialog } from '../../../Common/CommonActions.js'
import { undoTaskChange, updateTaskInCache } from '../TasksData'
import { getTaskEvents, receivedTaskEventsData } from '../TaskEventsData'
import Utils from '../../../Common/Utils'
import { debounce } from 'lodash-es';

import low from 'last-one-wins';

export const CLOSE_CREATE_UPDATE_TASK = 'CLOSE_CREATE_UPDATE_TASK'
export const CLOSE_TASK_DRAWER = 'CLOSE_TASK_DRAWER'
export const TASK_SELECTED = 'TASK_SELECTED'
export const SHOW_UNDO_SNACKBAR = 'SHOW_UNDO_SNACKBAR'
export const OPEN_FEEDBACK_DIALOG = 'OPEN_FEEDBACK_DIALOG'
export const HIDE_SPINNER = 'HIDE_SPINNER'
export const SHOW_SPINNER = 'SHOW_SPINNER'

export function deleteTask(id) {
  return (dispatch, getState) => {
    dispatch(closeCreateUpdateTask())

    const task = updateTaskInCache(id, { archived: true }, dispatch, getState())
    updateTaskOnServer(task, dispatch).then(() => {
      const message = 'Task deleted'
      dispatch(showUndoSnackbar(message))
    })
  }
}

export function completeTask(id, completeState) {
  return (dispatch, getState) => {
    dispatch(closeCreateUpdateTask())

    const task = updateTaskInCache(
      id,
      { completed: completeState },
      dispatch,
      getState()
    )
    updateTaskOnServer(task, dispatch).then(() => {
      const message = completeState ? 'Task complete' : 'Task incomplete'
      dispatch(showUndoSnackbar(message))
    })
  }
}

export function updateTask(task) {
  return (dispatch, getState) => {
    task = updateTaskInCache(task.id, task, dispatch, getState())
    dispatch(showSpinnerOnAutoSave())
    saveTaskWithDelay(dispatch, task)
  }
}

export function undoAndPreviousTask() {
  return (dispatch, getState) => {
    const previousTask = undoTaskChange(dispatch, getState)

    updateTaskOnServer(previousTask, dispatch, getState())
  }
}

const saveTaskWithDelay = debounce(function(dispatch, task) {
  saveTaskOnce({
    dispatch: dispatch,
    task: task,
  })
}, 1000)

const saveTaskOnce = low(function(params, callback) {
  const { task, dispatch } = params

  updateTaskOnServer(task, dispatch)
    .then(() => {
      dispatch(hideSpinnerAndShowSavedMessage())
    })
    .finally(() => {
      callback()
    })
})

function updateTaskOnServer(task, dispatch) {
  return TasksApi.update(task.id, {
    title: task.title,
    description: task.description,
    due: task.due,
    completed: task.completed || false,
    archived: task.archived || false,
    service_pro_id: getServiceProId(task.service_pro),
    customer_id: isPresent(task.customer) ? task.customer.id : null,
  })
    .then(() => {
      dispatch(getTaskEventUpdates(task.id))
    })
    .catch(error => {
      if (isPresent(error.response)) {
        dispatch(showErrorDialog(Utils.parseErrorMessage(error)))
      } else {
        alert('Unable to update task')
      }
    })
}

export function getTaskEventUpdates(taskId) {
  return (dispatch, getState) => {
    if (getTaskEvents(getState(), { taskId: taskId }).length > 0) {
      getTaskEventsUpdateWithDelay(dispatch, getState(), taskId)
    }
  }
}

let getTaskEventsUpdateWithDelay = debounce(function(dispatch, state, taskId) {
  return TasksApi.fetchTaskEvents(taskId).then(response => {
    dispatch(receivedTaskEventsData(response.data))
  })
}, 5000)

export function closeTaskDrawer() {
  return { type: CLOSE_TASK_DRAWER }
}

export function closeCreateUpdateTask() {
  return { type: CLOSE_CREATE_UPDATE_TASK }
}

function showUndoSnackbar(message) {
  return { type: SHOW_UNDO_SNACKBAR, message: message }
}

function getServiceProId(servicePro) {
  return isPresent(servicePro) ? servicePro.id : null
}

function hideSpinnerAndShowSavedMessage() {
  return { type: HIDE_SPINNER }
}

function showSpinnerOnAutoSave() {
  return { type: SHOW_SPINNER }
}
